import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "itemsContainer"]

  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    const selectedToken = urlParams.get("selectedToken") || ""
    const selectedNetwork = urlParams.get("selectedNetwork") || ""
    const storageKey = `addressBook_selected_${selectedToken}_${selectedNetwork}`
    
    const savedWalletAddress = sessionStorage.getItem(storageKey)
    
    if (this.itemTargets.length > 0) {
      // Deselect all items first
      this.itemTargets.forEach(item => {
        item.dataset.selected = "false"
      })
      
      // Try to find and select the previously selected item
      let selectedItem = null
      if (savedWalletAddress) {
        selectedItem = this.itemTargets.find(item => {
          return item.dataset.walletAddress === savedWalletAddress
        })
      }
      
      const itemToSelect = selectedItem || this.itemTargets[0]
      itemToSelect.dataset.selected = "true"
    }
  }

  select(event) {
    const item = event.currentTarget
    this.selectItem(item)
  }

  confirm(event) {
    const item = event.currentTarget
    this.selectItem(item)
    
    const walletAddress = item.dataset.walletAddress || ""
    
    // Set wallet address in crypto-select-asset controller via Stimulus value
    const formElement = document.querySelector('form[data-controller*="crypto-select-asset"]')
    if (formElement && walletAddress) {
      formElement.dataset.cryptoSelectAssetSelectedWalletValue = walletAddress
    }
    
    const bottomSheetController = this.application.getControllerForElementAndIdentifier(
      document.getElementById("bottomsheet-container"),
      "bottom-sheet"
    )
    if (bottomSheetController) {
      bottomSheetController.close()
    }
  }

  selectItem(item) {
    // Deselect all items
    this.itemTargets.forEach(wallet => {
      wallet.dataset.selected = "false"
    })

    item.dataset.selected = "true"

    const walletAddress = item.dataset.walletAddress || ""
    
    if (walletAddress) {
      const urlParams = new URLSearchParams(window.location.search)
      const selectedToken = urlParams.get("selectedToken") || ""
      const selectedNetwork = urlParams.get("selectedNetwork") || ""
      const storageKey = `addressBook_selected_${selectedToken}_${selectedNetwork}`
      sessionStorage.setItem(storageKey, walletAddress)
    }
  }
}

